import { useState } from "react";
import { CategoryList, CategoryType, getCategoryLable, getPriorityLable, PriorityList, PriorityType } from "./common";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MessageBox from "./message_box";

export default function NewTicket() {
    const [subject, setSubject] = useState<string>('');
    const [category, setCategory] = useState<CategoryType>('technical_support_connectivity');
    const [priority, setPriority] = useState<PriorityType>('medium');
    const theme = localStorage.getItem('theme') || 'dark';


    return <div className="ticket-page md:px-20 md:pt-5">
        <div className="ticket-form-shell md:flex md:flex-row-reverse md:items-start md:justify-between">
            <div className="ticket-form-selects flex flex-col md:flex-row">
                <FormControl className="ticket-select-control">
                    <InputLabel id="select-category-label">انتخاب دسته‌بندی</InputLabel>
                    <Select
                        labelId="select-category-label"
                        value={category}
                        label="انتخاب دسته‌بندی"
                        onChange={(e) => setCategory(e.target.value as CategoryType)}
                        className="ticket-themed-select"
                    >
                        { Object.values(CategoryList).map((cat) => (
                            <MenuItem key={cat} value={cat}>
                                {getCategoryLable(cat)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl className="ticket-select-control">
                    <InputLabel id="select-priority-label">اولویت</InputLabel>
                    <Select
                        labelId="select-priority-label"
                        value={priority}
                        label="اولویت"
                        onChange={(e) => setPriority(e.target.value as PriorityType)}
                        className="ticket-themed-select"
                    >
                        { Object.values(PriorityList).map((pri) => (
                            <MenuItem key={pri} value={pri}>
                                {getPriorityLable(pri)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="md:w-full md:ml-5">
                <label className="ticket-field-label block mt-4 mb-2 md:hidden">موضوع تیکت</label>
                <input
                    className="ticket-subject-input w-full text-sm p-2.5 rounded-lg"
                    placeholder="موضوع تیکت را وارد کنید..."
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    style={{padding: '0.625rem'}}
                />
            </div>
        </div>
        <MessageBox subject={subject} category={category} priority={priority} theme={theme} />
    </div>
}
